import { EventService } from '@nextgen-web-framework/core';
import { eventsPayloadTransformer } from '../transformers';
import { ProductEventsVersionsEnum } from '../types/enums/productEventsVersions';
import { ProductPublishEventType, ProductSubscribeEventType } from '../types/productTypes';

// Get topic name for pubsub events
const getEventTopicName = (event: string) => `product.domain.${event}`;

// Get timestamp
const getEventTimeStamp = () => new Date();

// setting source system as metadata for sample
const getEventSourceSystem = () => 'purchase.product';

// define version
const getCurrentEventVersion = () => ProductEventsVersionsEnum['1.0.0'];

const getMetaData = (event: string) => ({
  timestamp: getEventTimeStamp(),
  sourceSystem: getEventSourceSystem(),
  eventName: event,
  version: getCurrentEventVersion(),
});

export const ProductEvents = {
  publishEvent({ event, payload, message, sync = false }: ProductPublishEventType) {
    const eventData = {
      metadata: getMetaData(event),
      message,
      payload,
    };
    if (sync) {
      EventService.publishSync(getEventTopicName(event), eventData, eventsPayloadTransformer);
    } else {
      EventService.publish(getEventTopicName(event), eventData, eventsPayloadTransformer);
    }
  },
  subscribeEvents({ topics, version, cb }: ProductSubscribeEventType) {
    const topicArray: string[] = Array.isArray(topics) ? topics : Array.of(topics);
    const subscription = topicArray.map((topic: string) => ({
      topic: getEventTopicName(topic),
      version,
    }));
    const subs = EventService.subscribeMultiple(subscription, cb);
    return subs;
  },
  unsubscribe(subs: string | string[]) {
    EventService.unsubscribeMultiple(subs);
  },
};
export default ProductEvents;
